import { render, staticRenderFns } from "./SurveyCharts.vue?vue&type=template&id=061ce049&scoped=true"
import script from "./SurveyCharts.vue?vue&type=script&lang=js"
export * from "./SurveyCharts.vue?vue&type=script&lang=js"
import style0 from "./SurveyCharts.vue?vue&type=style&index=0&id=061ce049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ce049",
  null
  
)

export default component.exports